module.exports = __webpack_public_path__ + "img/img10.4b34ce02.svg";